import { Link } from "react-router-dom";
import type { ThemeCollection } from "@/types/movie";

interface ThemeSectionProps {
  themes: ThemeCollection[];
}

export default function ThemeSection({ themes }: ThemeSectionProps) {
  return (
    <section className="w-full px-4 pt-12 md:px-8">
      <div className="mb-6">
        <h2 className="font-heading text-2xl font-bold text-foreground-950">主题专题推荐</h2>
        <p className="mt-2 text-sm text-foreground-600">围绕不同伦理议题整理的合集，帮你一站式找到同类型影片</p>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
        {themes.map((theme) => (
          <Link
            key={theme.key}
            to={`/category?theme=${theme.key}`}
            className="group relative h-52 overflow-hidden rounded-lg border border-background-200/70"
          >
            <img
              src={theme.cover}
              alt={`${theme.name} 专题`}
              title={`${theme.name} 伦理影视专题`}
              className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/40 to-transparent"></div>
            <div className="absolute inset-x-0 bottom-0 p-4">
              <h3 className="font-heading text-lg font-bold text-background-50">{theme.name}</h3>
              <p className="mt-1 text-xs leading-relaxed text-background-100">{theme.subtitle}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-300">
                查看合集 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}